var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs":"12","md":"10","offset-md":"1"}},[_c('h1',{staticClass:"mb-4"},[_vm._v("Client Deposits")]),_c('client-deposits-card',{attrs:{"item":_vm.clientDeposits}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }